import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import { Form, Row, Col } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { AgGridReact } from "ag-grid-react";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import ButtonCom from "../../../components/button/button";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import {
  fetchData,
  saveRole,
  initRoleState,
} from "../../../redux/slices/roleSlice";
import { customStyles } from "../../../services/commonServices";
import {
  getSubAdminListPath,
  createSubAdminPath,
  updateSubAdminPath,
  deleteSubAdminPath,
  getAdminAssignedRolesPath,
  getParentRolePermissionsPath,
  saveParentRolePermissionsPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";
import TableSkeleton from "../../../components/table/TableSkeleton";

const Admins = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const {
    roleGetData,
    roleGetError,
    roleGetLoading,
    roleGetMessage,
    roleGetSuccess,
  } = useSelector((state) => state.roles);

  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [admin, setAdmin] = useState({
    userId: user?.user_id,
    user_id: "",
    name: "",
    mobile: "",
    email: "",
  });
  const [show, setShow] = useState(false);
  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isEdit, setIsEdit] = useState(false);
  const [parentUserId, setParentUserId] = useState("");

  const [adminName, setAdminName] = useState("");
  const [adminId, setAdminId] = useState("");
  const [show1, setShow1] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [filteredRoleList, setFilteredRoleList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [assignRoleState, setAssignRoleState] = useState({
    userId: "",
    parentUserId: user?.user_id,
    roleId: "",
  });

  const gridRef = useRef();
  const [isPermissionView, setIsPermissionView] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [filteredPermissions, setFilteredPermissions] = useState([]);

  const [activeUserId, setActiveUserId] = useState("");
  const [activeKey, setActiveKey] = useState("");
  const [activeRole, setActiveRole] = useState("");

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // Assign role permission start-----------------------------------------
  const openPermissionDialog = (userData) => {
    if (userData.roleId == "0") {
      toast.error("Please assign role first");
    } else {
      setActiveUserId(userData.userId);
      setActiveKey(userData.roleId);
      setActiveRole(userData.roleId);
      dispatch(fetchData());
      const data = {
        path: getParentRolePermissionsPath,
        data: {
          userId: userData.userId,
          parentUserId: user?.user_id,
          roleId: userData.roleId,
        },
      };
      dispatch(commonSaveDataOne(data));

      setIsPermissionView(true);
    }
  };
  const closePermissionDialog = () => {
    setIsPermissionView(false);
    setPermissions([]);
    setFilteredPermissions([]);
  };

  const handleChange = async (key) => {
    setActiveKey(key);
    if (activeRole != key) {
      const newArr = await filteredPermissions?.map((item) => {
        return {
          isMainModule: item.isMainModule,
          moduleId: item.moduleId,
          moduleName: item.moduleName,
          status: item.status,
          view: 0,
          create: item.create == null ? null : 0,
          edit: item.edit == null ? null : 0,
          delete: item.delete == null ? null : 0,
          export: item.export == null ? null : 0,
          approve: item.approve == null ? null : 0,
        };
      });
      setPermissions(newArr);
    } else {
      setPermissions(filteredPermissions);
    }
  };

  const CheckboxRenderer = (props) => {
    const handleInputChange = (e) => {
      const updatedValue = e.target.checked ? "1" : "0";
      props.node.setDataValue(props.colDef.field, updatedValue);
    };

    return props.value != null ? (
      <div className="custom-checkbox-wrapper">
        <input
          type="checkbox"
          className="custom-checkbox"
          checked={props.value === "1"}
          onChange={handleInputChange}
        />
      </div>
    ) : (
      <span style={{ marginLeft: "15px", color: "gray" }}>-</span>
    );
  };

  const heading = useMemo(
    () => [
      {
        headerName: "Permissions",
        field: "moduleName",
        pinned: "left",
        width: 450,
      },
      ...["view", "create", "edit", "delete", "export", "approve"].map(
        (key) => ({
          headerName: key.charAt(0).toUpperCase() + key.slice(1),
          field: key,
          cellRenderer: CheckboxRenderer,
          width: 110,
        })
      ),
    ],
    []
  );

  const saveChanges = () => {
    const rowData = [];
    gridRef.current.api.forEachNode((node) => {
      rowData.push(node.data);
    });

    const data = {
      path: saveParentRolePermissionsPath,
      data: {
        parentUserId: user?.user_id,
        userId: activeUserId,
        roleId: activeKey,
        permissions: rowData,
      },
    };
    dispatch(commonSaveData(data));
  };
  // Assign role permission end-------------------------------------------

  const handleModalClose1 = () => {
    setShow1(false);
    setRoleList([]);
  };
  const handleShow1 = () => setShow1(true);

  const handleAssignId = (data) => {
    setAssignRoleState((preState) => ({
      ...preState,
      userId: data.userId,
      roleId: data.roleId,
    }));
    setAdminId(data.userId);
    setAdminName(data.name);
    dispatch(fetchData());
  };

  const handleAssignRole = (val) => {
    setAssignRoleState((preState) => ({
      ...preState,
      roleId: val,
    }));
  };

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filteredRoleList.filter((v) =>
      v.rolename.toLowerCase().includes(val.toLowerCase())
    );
    setRoleList(filteredEmployees);
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: getAdminAssignedRolesPath,
      data: assignRoleState,
    };
    dispatch(commonSaveData(data));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setAdmin({
      ...admin,
      name: "",
      mobile: "",
      email: "",
    });
    setParentUserId("");

    setValidated(false);
    setOpen(false);
  };

  const getAdminList = useCallback(() => {
    dispatch(commonGetData(`${getSubAdminListPath}${user.user_id}`));
  }, []);

  useEffect(() => {
    getAdminList();
  }, []);

  const handelChange = (e) => {
    const { name, value } = e.target;
    if (name == "name") {
      if (/^[a-zA-Z]*$/.test(value)) {
        setAdmin({
          ...admin,
          [name]: value,
        });
        return;
      }
    } else {
      setAdmin({
        ...admin,
        [name]: value,
      });
    }
  };

  const handelMobileChange = (e) => {
    const input = e.target.value;
    if (/^\d{0,10}$/.test(input)) {
      setAdmin({
        ...admin,
        mobile: input,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let d = {
        path: createSubAdminPath,
        data: admin,
      };
      dispatch(commonSaveData(d));
    }
  };

  const handleEdit = (row) => {
    setIsEdit(true);
    setParentUserId(parseInt(row.data.parentUserId));
    setAdmin({
      ...admin,
      user_id: row.data.userId,
      name: row.data.name,
      mobile: row.data.mobile,
      email: row.data.email,
    });
    handleClickOpen();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    let d = {
      path: updateSubAdminPath,
      data: {
        userId: admin.user_id,
        parentUserId: parentUserId,
        name: admin.name,
        mobile: admin.mobile,
        email: admin.email,
      },
    };
    dispatch(commonSaveData(d));
  };

  const handleDelete = (row) => {
    setAdmin((pre) => ({
      ...pre,
      user_id: row.userId,
    }));
    setParentUserId(parseInt(row.parentUserId));
    handleShow();
  };

  const handleDeleteSubmit = () => {
    let d = {
      path: deleteSubAdminPath,
      data: {
        userId: admin.user_id,
        parentUserId,
      },
    };
    dispatch(commonSaveData(d));
    handleModalClose();
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      setOpen(false);
      handleClose();
      handleModalClose1();
      getAdminList();
      setIsEdit(false);
      setParentUserId("");
      setIsPermissionView(false);
      setAdmin((pre) => ({
        ...pre,
        name: "",
        email: "",
        mobile: "",
      }));
      dispatch(initCommonState());
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      setOpen(false);
      setIsEdit(false);
      handleClose();
      handleModalClose1();
      getAdminList();
      setParentUserId("");
      setAdmin((pre) => ({
        ...pre,
        name: "",
        email: "",
        mobile: "",
      }));
      dispatch(initCommonState());
    }
    // -------------------------------------------
    if (commonState.commonSuccessOne) {
      setPermissions(commonState.commonDataOne);
      setFilteredPermissions(commonState.commonDataOne);
      dispatch(initCommonState());
    }
    // -------------------------------------------
    if (commonState.commonGetSuccess) {
      setAdminList(commonState.commonGetData);
    }
    if (commonState.commonGetError) {
    }

    if (roleGetSuccess && roleGetData != null) {
      setRoleList(roleGetData);
      setFilteredRoleList(roleGetData);
    }
  }, [
    commonState,
    roleGetData,
    roleGetError,
    roleGetLoading,
    roleGetMessage,
    roleGetSuccess,
    dispatch,
  ]);

  const columns = [
    {
      headerName: "Name",
      cellRenderer: (row) => row.data.name,
      pinned: "left",
      width: "250px",
    },
    {
      headerName: "Mobile",
      cellRenderer: (row) => row.data.mobile,
      width: "100px",
    },
    {
      headerName: "Email",
      cellRenderer: (row) => row.data.email,
      width: "300px",
    },
    {
      headerName: "Role Name",
      cellRenderer: (row) => {
        return row.data.parentUserId == null
          ? "-"
          : row.data.roleName !== null
          ? row.data.roleName
          : "-";
      },

      flex: 1,
    },
    {
      headerName: "Status",
      cellRenderer: (row) => {
        return row.data.status == 1 ? "Active" : "InActive";
      },

      flex: 1,
    },
    {
      headerName: "Actions",
      cellRenderer: (row) => {
        return row.data.parentUserId == null ? null : (
          <div>
            {/* <MdOutlineAssignmentTurnedIn
              style={{
                cursor: "pointer",
                fontSize: 25,
                color: "#58d68d",
                marginRight: "10px",
              }}
              onClick={() => {
                handleShow1();
                handleAssignId(row.data);
              }}
            /> */}
            {HasPermission("Admins", "view") && (
              <MdOutlineRemoveRedEye
                style={{
                  cursor: "pointer",
                  fontSize: 25,
                  marginRight: "10px",
                }}
                className="eye-icon"
                onClick={() => openPermissionDialog(row.data)}
              />
            )}

            {HasPermission("Admins", "edit") && (
              <PiPencilSimpleLineBold
                style={{
                  cursor: "pointer",
                  fontSize: 30,
                  color: "blue",
                  marginRight: "10px",
                }}
                onClick={() => {
                  handleEdit(row);
                }}
              />
            )}

            {HasPermission("Admins", "delete") && (
              <RiDeleteBinLine className="delete-icon"
                style={{ cursor: "pointer", fontSize: 30, color: "red" }}
                onClick={() => handleDelete(row)}
              />
            )}

            {!HasPermission("Admins", "approve") &&
              !HasPermission("Admins", "edit") &&
              !HasPermission("Admins", "delete") &&
              "-"}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "200px",
    },
  ];
  const paginationPageSize = 10;

  const preSubmit = () => {
    const elem = document.querySelector("#preSubmit");
    if (elem) {
      elem.click();
    }
  };

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="SettingBody-card mt-4">
        <div className="Branches-container">
          <Widgets
            icon={
              <WidgetsIcon
                icon={
                  <Link to="/setting/" className="color-white">
                    <ArrowBackIcon />
                  </Link>
                }
                title="Company Sub Admin"
              />
            }
            button={
              HasPermission("Admins", "create") && (
                <ButtonCom
                  type={"button"}
                  class_name={"p_btn universal-btn"}
                  text={"Add SubAdmin"}
                  url_or_onclick={handleClickOpen}
                  icon={<AddIcon />}
                  width={""}
                />
              )
            }
            body={
              <>
                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 240px)",
                    width: "100%",
                    padding: "20px",
                  }}
                >
                  {commonState.commonGetLoading ? (
                    <TableSkeleton />
                  ) : (
                    <AgGridReact
                      columnDefs={columns}
                      rowData={Array.isArray(adminList) ? adminList : []}
                      omLayout="autoHeight"
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-between custom-pagination">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                </div>
              </>
            }
          />
        </div>

        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={open}
          onClose={handleClose}
          // className="dark-bg-color"
        >
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={handleClose}>
                X
              </span>
              <span className="title">
                {isEdit ? "Update Sub Admin" : "Add New Sub Admin"}
              </span>
            </div>
            <button
              className="universal-btn border-radius-8px"
              onClick={preSubmit}
              style={{ lineHeight: "10px", height: "30px", minWidth: "100px" }}
            >
              {isEdit ? "Update Changes" : "Add"}
            </button>
          </DialogTitle>

          <Form
            noValidate
            validated={validated}
            onSubmit={isEdit ? handleEditSubmit : handleSubmit}
          >
            <DialogContent>
              <Row>
                <Col sm="12">
                  <Form.Group className="mb-2">
                    <Form.Label className="color-white">Admin Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={admin.name}
                      placeholder="Enter Admin Name"
                      onChange={handelChange}
                      className="universal-input"
                      required
                    />
                    <Form.Control.Feedback type={"invalid"}>
                      Please provide valid sub admin name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm="12">
                  <Form.Group className="mb-2">
                    <Form.Label className="color-white">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={admin.email}
                      placeholder="Enter Email"
                      onChange={handelChange}
                      className="universal-input"
                      required
                    />
                    <Form.Control.Feedback type={"invalid"}>
                      Please provide valid email id.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm="12">
                  <Form.Group className="mb-2">
                    <Form.Label className="color-white">
                      Mobile Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile"
                      pattern="\d*"
                      value={admin.mobile}
                      placeholder="Enter Mobile Number"
                      onChange={handelMobileChange}
                      className="universal-input"
                      required
                    />
                    <Form.Control.Feedback type={"invalid"}>
                      Please provide valid mobile number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Button
                variant="contained"
                color="info"
                type="submit"
                id="preSubmit"
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  lineHeight: "30px",
                  display: "none",
                }}
              >
                Save
              </Button>
            </DialogContent>
          </Form>
        </Dialog>
      </div>
      {/* ---------------------------------------- */}
      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="color-white">Delete Sub Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ---------------------------------------- */}
      <Modal show={show1} onHide={handleModalClose1} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: "10px",
            }}
          >
            <h4>Assign Role To Sub Admin</h4>
            <span> Admin Name - {adminName}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
          <input
            className="search-employee"
            type="text"
            placeholder="Search role..."
            value={searchQuery}
            onChange={(e) => searchEmployees(e.target.value)}
          />
          <table className="admin-tbl">
            <thead>
              <tr>
                <th>
                  &nbsp; &nbsp;
                  <label style={{ cursor: "pointer" }} htmlFor="sel-all">
                    Select
                  </label>
                </th>
                <th>Role Name</th>
              </tr>
            </thead>
            <tbody>
              {roleList?.map((role, idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <input
                        type="radio"
                        name="roleId"
                        value={role.roleId}
                        checked={assignRoleState.roleId == role.roleId}
                        onChange={(e) => handleAssignRole(e.target.value)}
                        id={"role" + role.roleId}
                        className="colored-checkbox"
                      />
                    </td>
                    <td>
                      <span>{role.rolename}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#566573",
              color: "#fff",
              width: "100px",
              height: "30px",
              border: "none",
              marginRight: "5px",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button
            style={{
              color: "#fff",
              width: "100px",
              height: "30px",
              border: "none",
            }}
            onClick={handleAssignShiftSubmit}
            className="universal-btn"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Role permissions ------------------------------ */}
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={isPermissionView}
        onClose={closePermissionDialog}
      >
        <DialogTitle
          style={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="d-flex align-items-center justify-content-start gap-2">
              <button
                onClick={closePermissionDialog}
                className="universal-input-one d-flex align-items-center justify-content-center"
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "7px",
                }}
              >
                X
              </button>
              <span>Role Permission</span>
            </span>
            <button className="universal-btn" onClick={saveChanges}>
              Save Changes
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="accordion-wrapper mt-3">
            <Accordion activeKey={activeKey}>
              {roleList?.map((rowItem, idx) => {
                return activeKey === rowItem.roleId ? (
                  <Card key={idx}>
                    <Card.Header>
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          id={`radio${idx}`}
                          name="accordionRadio"
                          className="custom-control-input"
                          checked={activeKey === rowItem.roleId}
                          onChange={() => handleChange(rowItem.roleId)}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`radio${idx}`}
                        >
                          {rowItem.rolename}
                        </label>
                      </div>
                    </Card.Header>
                    <Accordion.Collapse eventKey={rowItem.roleId}>
                      <Card.Body>
                        {activeKey === rowItem.roleId && (
                          <div
                            className="ag-theme-quartz custom-grid mt-3"
                            style={{
                              height: "calc(100vh - 280px)",
                              width: "100%",
                            }}
                          >
                            {commonState.commonLoadingOne ? (
                              <TableSkeleton />
                            ) : (
                              <AgGridReact
                                ref={gridRef}
                                rowData={
                                  Array.isArray(permissions)
                                    ? permissions.map((p) => ({ ...p }))
                                    : []
                                }
                                columnDefs={heading}
                                immutableData={true} // Important!
                                getRowNodeId={(data) => data.id}
                                suppressCellFocus={true}
                              />
                            )}
                          </div>
                        )}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ) : null;
              })}
            </Accordion>
          </div>
        </DialogContent>
      </Dialog>
      {/* Role permissions ends ------------------------- */}
    </div>
  );
};

export default Admins;
